import { useEffect, useRef } from 'react';
import QRCodeStyling from 'qr-code-styling';

type StyledQRCodeProps = {
  value: string;
  size?: number;
};

const WebQRCode = ({ value, size = 200 }: StyledQRCodeProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const qrCode = useRef<QRCodeStyling | null>(null);

  // Initialize QR code instance on mount
  useEffect(() => {
    qrCode.current = new QRCodeStyling({
      width: size,
      height: size,
      data: value,
      margin: 0,
      type: 'svg',
      qrOptions: {
        typeNumber: 0,
        mode: 'Byte',
        errorCorrectionLevel: 'H',
      },
      dotsOptions: {
        type: 'dots',
        gradient: {
          type: 'radial',
          rotation: 0,
          colorStops: [
            { offset: 0, color: '#A0A8DF' },
            { offset: 1, color: '#6370CA' },
          ],
        },
      },
      backgroundOptions: {
        color: 'transparent',
      },
      cornersSquareOptions: {
        type: 'extra-rounded',
        gradient: {
          type: 'radial',
          rotation: 0,
          colorStops: [
            { offset: 0, color: '#A0A8DF' },
            { offset: 1, color: '#6370CA' },
          ],
        },
      },
      cornersDotOptions: {
        type: 'dot',
        gradient: {
          type: 'radial',
          rotation: 0,
          colorStops: [
            { offset: 0, color: '#A0A8DF' },
            { offset: 1, color: '#6370CA' },
          ],
        },
      },
    });

    if (ref.current) {
      ref.current.innerHTML = '';
      qrCode.current.append(ref.current);
    }
    // Only recreate when size changes
    // value updates are handled by the second effect for better performance
  }, [size, value]);

  // Update QR code data when value changes
  useEffect(() => {
    if (qrCode.current) {
      qrCode.current.update({ data: value });
    }
  }, [value]);

  return (
    <div
      ref={ref}
      style={{
        width: size,
        height: size,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    />
  );
};

export const StyledQRCode = (props: StyledQRCodeProps) => {
  return <WebQRCode {...props} />;
};
